import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape} from 'react-intl';
import {reduxForm, FormSection, Form, submit} from 'redux-form';
import _ from 'lodash';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import { spinnerOpen } from '../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { submitSepaApi } from './SepaPageActions';
import Button, {BUTTON_STYLE} from '../../../../shared-components/Button/Button';
import Footer from '../../../components/Footer/Footer';
import Header from '../../../components/Header/Header';
import {FORM_ID} from '../../../../framework/App/AppConstants';
import { APPLICATION_STATUS } from '../../../config/DEConstants';
import Col from '../../../../shared-components/VXGrid/Col';
import Row from '../../../../shared-components/VXGrid/Row';
import './SepaPage.less';
import UserInfoDisplay from '../../../components/UserInfoDisplay/UserInfoDisplay';
import Bank from '../../../components/Bank/Bank';
import Creditor from '../../../components/Creditor/Creditor';
import Agreement from '../../../components/Agreement/Agreement';

const LOCALE_PREFIX = 'DE/pages/SepaPage/SepaPage';

export class SepaPage extends Component {
    static propTypes = {
        _csrf: PropTypes.string.isRequired,
        intl: intlShape.isRequired,
        onClickApply: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        onFormSubmit: PropTypes.func.isRequired,
        // Provided from decorated reduxForm() component
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool // Redux inject this to indicate if the form submit is still in progress
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount(this.props);
    }

    render() {
        const {intl, onClickApply, handleSubmit, onFormSubmit, _csrf, submitting} = this.props;

        return (
            <div className="outerWrapper de-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="SepaPage">
                            <Header singleColumnLayout={true} msg={intl.formatMessage({id: `${LOCALE_PREFIX}.sepaTitle`})} />
                            <div id="content">
                                <div id="content-child" className="row-fluid table-layout">
                                    <section className="contentSection">

                                        <div className="formWrapper">
                                            <Form
                                                action="sepa"
                                                id="SepaMandateForm"
                                                method="post"
                                                className="proceed"
                                                onSubmit={handleSubmit(onFormSubmit)}
                                            >
                                                <input id="csrf" type="hidden" name="_csrf" value={_csrf} />

                                                <p className="primary"><FormattedMessage id={`${LOCALE_PREFIX}.sepaAgreementPara1`} /></p>

                                                <FormSection name="sepa-info">

                                                    <div className="accountDetails">
                                                        <Row gutterSize={30}>

                                                            <Col xs={4}>
                                                                <UserInfoDisplay />
                                                            </Col>

                                                            <Col xs={4}>
                                                                <Bank />
                                                            </Col>

                                                            <Col xs={4}>
                                                                <Creditor />
                                                            </Col>

                                                        </Row>
                                                    </div>

                                                </FormSection>

                                                <p className="secondary"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.sepaAgreementPara2WithoutLink`} /></p>

                                                <Agreement />

                                                <div className="continue-button-wrapper">
                                                    <Button
                                                        data-automation-id="continue"
                                                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                                        className="bmlApplyContinue"
                                                        id="bmlApplyContinue"
                                                        onClick={onClickApply}
                                                        disabled={submitting}
                                                    >
                                                        {intl.formatMessage({id: `${LOCALE_PREFIX}.agreeBtn`})}
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />

            </div>
        );
    }


}

export const mapStateToProps = state => ({
    _csrf: _.get(state, 'serverData._csrf', ''),
    applicationStatus: _.get(state, 'serverData.decisionModel.applicationStatus')
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount(props) {
        dispatch(trackTransition('pp_credit_sepapage', 'prepare_sepapage_pp_credit'));
        if (props.applicationStatus !== APPLICATION_STATUS.VIEW_SEPA) {
            dispatch(submit(FORM_ID));
        }
    },
    onClickApply() {
        dispatch(submit(FORM_ID));
    },
    onFormSubmit(formValues) {
        dispatch(trackTransition('pp_credit_sepapage', 'process_sepapage_pp_credit'));
        dispatch(spinnerOpen());
        return dispatch(submitSepaApi(formValues, LOCALE_PREFIX));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(SepaPage)
));
